module.exports = __webpack_public_path__ + "static/007-slideshow-80b9c8b8dc0cac0245f48f7829b7a9cc.jpg";